// extracted by mini-css-extract-plugin
export default {"removeBorder":"removeBorder--pW6Je","dialogBox":"dialogBox--sCSqR","description":"description--_IztG","fullWidth":"fullWidth--z9opq"};